import { queryOptions } from "@tanstack/react-query";
import {
  getCategories,
  getProductBySlug,
  getProducts,
  searchProducts,
} from "@/lib/products.functions";

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  sort_order: number;
  parent_id: string | null;
}

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonValue[]
  | { [key: string]: JsonValue };

export interface Product {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  short_description: string | null;
  price: number | null;
  compare_at_price: number | null;
  stock_quantity: number;
  category_id: string | null;
  sku: string | null;
  is_active: boolean;
  is_featured: boolean;
  is_custom_quote: boolean;
  images: string[];
  technical_specs: Record<string, JsonValue>;
  tags: string[];
  category?: Category | null;
  weight_kg: number | null;
  height_cm: number | null;
  width_cm: number | null;
  length_cm: number | null;
  ncm: string | null;
  gtin: string | null;
  unit: string | null;
  brand: string | null;
}

export const productsQuery = () =>
  queryOptions({
    queryKey: ["products"],
    queryFn: () => getProducts(),
  });

export const categoriesQuery = () =>
  queryOptions({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
  });

export const productBySlugQuery = (slug: string) =>
  queryOptions({
    queryKey: ["product", slug],
    queryFn: () => getProductBySlug({ data: slug }),
  });

export const searchProductsQuery = (query: string) =>
  queryOptions({
    queryKey: ["products", "search", query],
    queryFn: () => searchProducts({ data: query }),
    enabled: query.trim().length > 0,
  });

const SPEC_LABELS: Record<string, string> = {
  disjuntores: "Disjuntores",
  circuitos: "Circuitos",
  corrente_nominal: "Corrente nominal",
  tensao: "Tensão",
  norma: "Norma",
  grau_protecao: "Grau de proteção",
  material: "Material",
  barramento: "Barramento",
  protecoes: "Proteções",
  categoria: "Categoria",
  tipo: "Tipo",
  prazo_orcamento: "Prazo de orçamento",
  prazo_producao: "Prazo de produção",
  garantia: "Garantia",
};

export function specLabel(key: string): string {
  return SPEC_LABELS[key] ?? key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
